var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkbox-list"},_vm._l((_vm.value),function(checkbox){return _c('b-checkbox',{key:checkbox.label,model:{value:(checkbox.data),callback:function ($$v) {_vm.$set(checkbox, "data", $$v)},expression:"checkbox.data"}},[_vm._v("\n    "+_vm._s(checkbox.label)+"\n  ")])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-358ca796","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/lib/components/MultiCheckbox.vue
// module id = i57G
// module chunks = 1